import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthService } from '../../../services/Api'
import { APP_CONSTANTS } from '../Common/globals'

export const useAuth = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const login = async (credentials) => {
    setLoading(true)
    setError("")

    try {
      const data = await AuthService.login(credentials)

      if (data.success) {
        // Store tokens and user data
        AuthService.storeTokens(data.data.tokens)
        AuthService.storeUserData(data.data.user)

        // Navigate based on role
        const userData = data.data.user
        switch (userData.role) {
          case APP_CONSTANTS.ROLES.ADMIN:
            navigate(APP_CONSTANTS.ROUTES.ADMIN_DASHBOARD)
            break
          case APP_CONSTANTS.ROLES.DEVELOPER:
            navigate(APP_CONSTANTS.ROUTES.DEVELOPER_DASHBOARD)
            break
          case APP_CONSTANTS.ROLES.AGENT:
            navigate(APP_CONSTANTS.ROUTES.AGENT_DASHBOARD)
            break
          case APP_CONSTANTS.ROLES.LEAD:
          default:
            navigate(APP_CONSTANTS.ROUTES.PROFILE)
            break
        }
      } else {
        // Handle non-success response
        if (data.errors?.non_field_errors) {
          setError(data.errors.non_field_errors[0])
        } else {
          setError(data.message || "Login failed. Please try again.")
        }
      }
    } catch (err) {
      console.error("Login error:", err.response?.data)
      // Handle error response with non_field_errors
      if (err.response?.data?.errors?.non_field_errors) {
        setError(err.response.data.errors.non_field_errors[0])
      } else {
        setError(err.response?.data?.message || "Failed to login. Please try again.")
      }
    } finally {
      setLoading(false)
    }
  }

  return { login, loading, error }
}